module.exports = __webpack_public_path__ + "static/img/smudge_overlay-orange.dcce506.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/smudge_overlay-orange.png
// module id = 1371
// module chunks = 0